module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "msgbox-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "zk-message-box__wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "zk-message-box"
  }, [(_vm.title !== '') ? _c('div', {
    staticClass: "zk-message-box__header"
  }, [_c('div', {
    staticClass: "zk-message-box__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showClose) ? _c('i', {
    staticClass: "zk-message-box__close zk-icon-close",
    on: {
      "click": function($event) {
        _vm.handleAction('cancel')
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.message !== '') ? _c('div', {
    staticClass: "zk-message-box__content"
  }, [_c('div', {
    staticClass: "zk-message-box__status",
    class: [_vm.typeClass]
  }), _vm._v(" "), _c('div', {
    staticClass: "zk-message-box__message",
    style: ({
      'margin-left': _vm.typeClass ? '50px' : '0'
    })
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInput),
      expression: "showInput"
    }],
    staticClass: "zk-message-box__input"
  }, [_c('zk-input', {
    ref: "input",
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zk-message-box__errormsg",
    style: ({
      visibility: !!_vm.editorErrorMessage ? 'visible' : 'hidden'
    })
  }, [_vm._v(_vm._s(_vm.editorErrorMessage))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zk-message-box__btns"
  }, [_c('zk-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCancelButton),
      expression: "showCancelButton"
    }],
    class: [_vm.cancelButtonClasses],
    nativeOn: {
      "click": function($event) {
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelButtonText))]), _vm._v(" "), _c('zk-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmButton),
      expression: "showConfirmButton"
    }],
    ref: "confirm",
    class: [_vm.confirmButtonClasses],
    nativeOn: {
      "click": function($event) {
        _vm.handleAction('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmButtonText))])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-b77ddcb8"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/message-box/src/messageBox.vue
// module id = 281
// module chunks = 0